import React, {useState} from 'react';
import ArrDatePicker from '../../../components/common/arr-date-picker/ArrDatePicker';

const TimeInputDemo: React.FC = () => {
  const [dateValue, setDateValue] = useState<
    string | [] | [string | undefined, string | undefined]
  >('');
  const handleChange = (
    value: string | [] | [string | undefined, string | undefined]
  ) => {
    setDateValue(value);
  };

  return (
    <div style={{maxWidth: 400, margin: '0 auto', padding: 24}}>
      <h2>ArrTimePicker</h2>
      <ArrDatePicker
        type="date-picker"
        label="Time Picker"
        placeholder="HH:mm:ss"
        onChange={handleChange}
        applyEnable={true}
        mode="time"
        ampm={false}
        dataTestId="demo-component"
      />
      <div style={{marginTop: 16}}>
        <strong>Selected Time:</strong> {dateValue}
      </div>
    </div>
  );
};

export default TimeInputDemo;
